// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
export default Marty.createActionCreators({
  // Add action helpers here for server resources
  saveMessageUserDraft(draft) {
    return this.app.stores.DraftStore.saveMessageUserDraft(draft)
  },

  saveEmailCaptureDraft(draft) {
    return this.app.stores.DraftStore.saveEmailCaptureDraft(draft)
  },

  // Add action helpers here for server resources
  saveNPSDraft(draft) {
    return this.app.stores.DraftStore.saveNPSDraft(draft)
  }
})



// WEBPACK FOOTER //
// ./src/scripts/actions/DraftActions.js